import LaneLabelRenderer from "./lane-label-renderer";

export default {
    __init__: ["LaneLabelRenderer"],
    LaneLabelRenderer: ["type", LaneLabelRenderer],
};
